export const CONTACT_FILTERS = 1
export const MERCHANT_FILTERS = 2
export const SHIPPERS_FILTERS = 3
export const TRUCK_SALES_DEALER_FILTERS = 4
export const FINANCE_DEALER_FILTERS = 5
export const EMAIL_TEMPLATE_FILTERS = 6
